module.exports = __webpack_public_path__ + "img/grupocoruja.70da8977.png";